import http from "../../http";
export default {
  exportApiUrl:
    process.env.VUE_APP_API_ROOT +
    "activityservice/activitylive/netapi/live/info/excel",
  exportApi1Url:
    process.env.VUE_APP_API_ROOT +
    "activityservice/activitylive/netapi/bg/count/detail/export",
  exportLive: (params) => {
    return http.post("activityservice/activitylive/netapi/live/info/excel", params);
  },
  exportLive1: (params) => {
    return http.post("activityservice/activitylive/netapi/bg/count/detail/export", params);
  },
  getLive: params => {
    return http.get("activityservice/video/modifyBaseInfo", params);
  },
  list: params => {
    return http.post("activityservice/activitylive/bg/list", params);
  },
  add: params => {
    return http.post("activityservice/activitylive/create", params);
  },
  update: params => {
    return http.post("activityservice/activitylive/update", params);
  },
  getVideoInfo(params) {
    return http.get("activityservice/video/get", params);
  },
  del: params => {
    return http.get("activityservice/activitylive/remove", params);
  },
  // 获取直播的数据
  liveData: params => {
    return http.get("activityservice/activitylive/live/info", params);
  },
  // 未开播用户观看详情
  zhiboWeikaiDetail: params => {
    return http.get("activityservice/activitylive/live/readview/info", params);
  },
  // 直播观看详情
  zhiboPvDetail: params => {
    return http.get("activityservice/activitylive/live/view/info", params);
  },
  // 回看观看详情
  zhiboRecordDetail: params => {
    return http.get("activityservice/activitylive/live/review/info", params);
  },
  // 获取直播推拉流地址
  getTuiLaInfo: params => {
    return http.get("activityservice/activitylive/stream", params);
  },
  // 停止直播
  stopLive: params => {
    return http.post("activityservice/activitylive/stop", params);
  },
  // 获取直播设置
  getLiveSetting: params => {
    return http.post("activityservice/activitylive/setting", params);
  },
  // 获取直播聊天
  getChatList: params => {
    return http.get("activityservice/activitylive/chat", params);
  },
  // 审核聊天
  auditChat: params => {
    return http.post("activityservice/activitylive/chat/audit", params);
  },
  // 更新高级设置
  updateSetting: params => {
    return http.post("activityservice/activitylive/setting", params);
  }
};
